import React from 'react';
import useAuth from '../../hooks/useAuth';

const MealDetails = ({ id, setChecked, getValues, setValue, name, price, components, tags = [], allergens = [], total, setTotal}) => {
    let mealComponents, mealTags, mealAllergens, priceBlock, componentsPhrase = undefined
    const { setShowModal } = useAuth();

    const closeModal = async () => {
        setShowModal(false)
        let dishes = getValues('dishes');
        if (dishes.includes(String(id))) {
            const index = dishes.indexOf(String(id));
            dishes.splice(index, 1);
            setValue('dishes', dishes);
            setTotal(total-price);
            setChecked(false);
        }
    };

    if( price > 0 ){
        priceBlock = 
            <div className='meal-price'><i className='fw-bold'>{ new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(price) }</i></div>
    }

    if( components.length > 1 ){
        componentsPhrase = components.join(', ').toLowerCase()
        mealComponents = <label><i>{componentsPhrase[0].toUpperCase() + componentsPhrase.slice(1)}</i></label>
    }else{
        mealComponents = <div><i>NC</i></div>
    }

    if( tags.length > 0 ){
        mealTags = tags.map((tag, key) =>
            <div key={key}><img style={{width:20}} src={`/images/${tag.icon}`} alt={tag.name}></img><i>{tag.name}</i></div>
        );
    }else{
        mealTags = <div><i>NC</i></div>
    }

    if( allergens.length > 0 ){
        mealAllergens = allergens.map((allergen, key) =>
            <div className='d-flex align-items-center' key={key}><img className='allergen' src={`/images/${allergen.icon}`} alt={allergen.name}></img><i>{allergen.name}</i></div>
        );
    }else{
        mealAllergens = <div><i>NC</i></div>
    }

    return (
        <>
            <div className='bg-white rounded m-1 d-flex flex-column p-1'>
                <div className='d-flex'>
                    <div role='presentation' className='meal-back' onClick={() => closeModal()}><span className='back-meal-modal'><i className='fa-solid fa-chevron-left'></i></span></div>
                    <div className='meal-name'><u className='fw-bold'>{name}</u></div>
                    {priceBlock}
                </div>

                <div className='meal-details'>
                    <div className='d-flex flex-column flex-grow-1 flex-shrink-1'>
                        <div className='meal-detail-category'>Composition</div>
                        <div className='metal-detail-category-data'>{mealComponents}</div>
                    </div>

                    <div className='d-flex flex-column flex-grow-1 flex-shrink-1'>
                        <div className='meal-detail-category'>Labels</div>
                        <div className='metal-detail-category-data'>{mealTags}</div>
                    </div>

                    <div className='d-flex flex-column flex-grow-1 flex-shrink-1'>
                        <div className='meal-detail-category'>Allergènes</div>
                        <div className='metal-detail-category-data'>{mealAllergens}</div>
                    </div>
                </div>

                {/* <div className='mt-1 d-flex flex-column'>
                    {mealAccompaniementsBlock}
                    <div className='d-flex justify-content-center'>
                        <button className='meal-submit meal-detail-submit' onClick={() => chooseMeal()}>{submitText}</button>
                    </div>
                </div> */}
            </div>
        </>
    )
}

export default MealDetails
